export const environment = {
  production: true,
  apiUrl: 'https://api-managment-digitalizcija.azure-api.net/isbpwebapi-test/',
  keycloak: {
    clientId: 'isbp-employees-sunbeds',
    realm: 'isbp-test',
    url: ' https://wa-euwe-keycloak-test-01.azurewebsites.net/',
    logoutUrl: 'https://mango-grass-05a9b0a03.6.azurestaticapps.net/logout',
  },
  useApim: true,
  secret: '4832f02c7fcd44658fecdc7cbbce42be',
};
